var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnapterEnergyStorage100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1394 53.0598L9.60938 40.7798",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6999 46.46L46.6899 48.77L44.4199 56.7L47.1199 55.14L44.8499 63.19L51.9899 49.59L48.6399 51.52L50.6999 46.46Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1406 77.9102V96.2402",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6999 68.1001L46.6899 70.4101L44.4199 78.3301L47.1199 76.7701L44.8499 84.8201L51.9899 71.2201L48.6399 73.1501L50.6999 68.1001Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3405 35.1902L40.8105 22.9102",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3394 39.3398V56.8298L31.1394 74.6898L9.60938 62.4098",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5406 17.3301L31.1406 53.0601V74.6101",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8892 28.6001L77.8891 30.9101L75.6191 38.8401L78.3191 37.2801L76.0491 45.3301L83.1891 31.7201L79.8291 33.6601L81.8892 28.6001Z",
    fill: "#BDBDBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3398 60.8701V78.3801",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5401 38.9702L65.8301 54.8302",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.54 60.52L31.14 96.24L6 81.9V38.72L68.4 3L93.54 17.33V60.52Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8892 50.2402L77.8891 52.5402L75.6191 60.4702L78.3191 58.9102L76.0491 66.9602L83.1891 53.3502L79.8291 55.2902L81.8892 50.2402Z",
    fill: "#BDBDBD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0801 39.6198C30.1095 39.3255 30.218 39.0447 30.3941 38.807C30.5701 38.5693 30.8072 38.3837 31.0801 38.2698C31.8044 37.9049 32.6041 37.7148 33.4151 37.7148C34.2261 37.7148 35.0258 37.9049 35.7501 38.2698C36.0349 38.3627 36.2831 38.5433 36.459 38.7858C36.635 39.0283 36.7297 39.3202 36.7297 39.6198C36.7297 39.9194 36.635 40.2113 36.459 40.4538C36.2831 40.6963 36.0349 40.8769 35.7501 40.9698C34.8015 41.4563 33.7248 41.6346 32.6701 41.4798",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0801 39.6201V44.3601C30.1102 44.653 30.2191 44.9322 30.3952 45.1681C30.5712 45.404 30.8079 45.5879 31.0801 45.7001C31.803 46.0696 32.6032 46.2623 33.4151 46.2623C34.2269 46.2623 35.0272 46.0696 35.7501 45.7001C36.021 45.5861 36.2566 45.4017 36.4324 45.1662C36.6082 44.9306 36.7179 44.6523 36.7501 44.3601V39.6201",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1504 32.13C43.1799 31.8357 43.2884 31.5549 43.4644 31.3173C43.6404 31.0796 43.8775 30.894 44.1504 30.78C44.8747 30.4152 45.6744 30.2251 46.4854 30.2251C47.2964 30.2251 48.0961 30.4152 48.8204 30.78C49.1004 30.8779 49.3431 31.0603 49.5148 31.3022C49.6865 31.5441 49.7788 31.8334 49.7788 32.13C49.7788 32.4267 49.6865 32.716 49.5148 32.9578C49.3431 33.1997 49.1004 33.3822 48.8204 33.48C47.8977 33.9582 46.851 34.1431 45.8204 34.01",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1504 32.1299V36.8699C43.1819 37.1635 43.2912 37.4434 43.467 37.6807C43.6428 37.918 43.8787 38.1042 44.1504 38.2199C44.8764 38.5849 45.6778 38.7749 46.4904 38.7749C47.303 38.7749 48.1044 38.5849 48.8304 38.2199C49.1021 38.1042 49.338 37.918 49.5138 37.6807C49.6896 37.4434 49.7989 37.1635 49.8304 36.8699V32.1299",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2793 21.8001C61.3088 21.5058 61.4173 21.225 61.5933 20.9873C61.7693 20.7496 62.0064 20.564 62.2793 20.4501C63.0053 20.0851 63.8067 19.895 64.6193 19.895C65.4319 19.895 66.2333 20.0851 66.9593 20.4501C67.2322 20.564 67.4692 20.7496 67.6453 20.9873C67.8213 21.225 67.9298 21.5058 67.9593 21.8001C67.9309 22.0947 67.8228 22.376 67.6466 22.6138C67.4705 22.8517 67.2328 23.037 66.9593 23.1501C66.0366 23.6276 64.988 23.8059 63.9593 23.6601",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2793 21.7998V26.5298C61.3088 26.8241 61.4173 27.1049 61.5933 27.3426C61.7693 27.5802 62.0064 27.7659 62.2793 27.8798C63.0022 28.2493 63.8024 28.442 64.6143 28.442C65.4262 28.442 66.2264 28.2493 66.9493 27.8798C67.2228 27.7668 67.4604 27.5814 67.6366 27.3436C67.8128 27.1057 67.9209 26.8244 67.9493 26.5298V21.7998",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3398 14.2702C74.3704 13.9762 74.4792 13.6958 74.6552 13.4584C74.8311 13.2209 75.0675 13.035 75.3398 12.9202C76.0641 12.5553 76.8638 12.3652 77.6748 12.3652C78.4858 12.3652 79.2856 12.5553 80.0098 12.9202C80.2834 13.0332 80.521 13.2186 80.6972 13.4564C80.8733 13.6942 80.9814 13.9756 81.0098 14.2702C80.9814 14.5648 80.8733 14.8461 80.6972 15.0839C80.521 15.3218 80.2834 15.5071 80.0098 15.6202C79.1126 16.0883 78.0944 16.2731 77.0898 16.1502",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3398 14.27V19C74.3704 19.294 74.4792 19.5743 74.6552 19.8118C74.8311 20.0493 75.0675 20.2352 75.3398 20.35C76.0627 20.7195 76.863 20.9122 77.6748 20.9122C78.4867 20.9122 79.287 20.7195 80.0098 20.35C80.2834 20.237 80.521 20.0516 80.6972 19.8138C80.8733 19.5759 80.9814 19.2946 81.0098 19V14.27",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnapterEnergyStorage100);
export default __webpack_public_path__ + "static/media/enapter-energy-storage-100.fc8b3da55787dd63b7faf5f5ba548618.svg";
export { ForwardRef as ReactComponent };